import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  BuyerState,
  getCategories
} from '~app/modules/generic/store';
import { Observable, Subject } from 'rxjs';
import { Category } from '~app/modules/generic/models';
import { isPlatformBrowser } from '@angular/common';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { filter, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-generic-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  private destroySubject$ = new Subject();
  
  homeHeaderCategories$: Observable<Category[]>;
  hostUrl: string;
  isClient: boolean;
  isAccountSubsidiary: boolean;

  constructor(
    private store: Store<BuyerState>,
    @Inject(PLATFORM_ID) private platformId: Object,
    private accountInfoService: AccountInfoService
  ) {
    this.initializeHomeNavbarCategories();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.hostUrl = `${window.location.protocol}//${window.location.host}/${window.location.pathname.split('/')[1]}`;
      this.isClient = true;
    }
    this.updateIsAccountSubsidiaryStatus();
  }

  private initializeHomeNavbarCategories(): void {
    //Home top navbar categories
    this.homeHeaderCategories$ = this.store.pipe(select(getCategories));
  }

  private updateIsAccountSubsidiaryStatus(): void {
    this.accountInfoService
      .getAccountInfo()
      .pipe(
        takeUntil(this.destroySubject$),
        filter((accountInfo) => accountInfo !== null)
      )
      .subscribe((accountInfo) => {
        this.isAccountSubsidiary = accountInfo?.isSubsidiary;
      });
  }
}
